import { Block, PrintDocument, RenderOutput } from '../document'
import { ascii, row, wrap } from '../text'

const ESC = 0x1b
const GS = 0x1d
const LF = 0x0a

/** Star Line Mode (Star TSP100 / TSP650 / mC-Print in line mode). QR prints its text; images are skipped. */
export const renderStar = (doc: PrintDocument, p: Record<string, any>): RenderOutput => { // eslint-disable-line @typescript-eslint/no-explicit-any
  if (doc.kind === 'sheet') throw new Error('A receipt printer cannot print a page of labels')
  const width = Number(p.chars_per_line)
  const out: number[] = [ESC, 0x40]
  if (doc.kind === 'roll' && doc.drawer) out.push(0x07)

  const line = (text: string) => out.push(...ascii(text), LF)
  const align = (a = 'left') => out.push(ESC, GS, 0x61, a === 'center' ? 1 : a === 'right' ? 2 : 0)
  const bold = (on: boolean) => out.push(ESC, on ? 0x45 : 0x46)

  const block = (b: Block) => {
    switch (b.type) {
      case 'text':
        align(b.align)
        bold(!!b.bold)
        if (b.size === 2) out.push(ESC, 0x69, 1, 1)
        for (const l of wrap(b.text, b.size === 2 ? Math.floor(width / 2) : width)) line(l)
        if (b.size === 2) out.push(ESC, 0x69, 0, 0)
        bold(false)
        break
      case 'row':
        align('left')
        bold(!!b.bold)
        line(row(b.left, b.right, width))
        bold(false)
        break
      case 'rule':
        align('left')
        line('-'.repeat(width))
        break
      case 'feed':
        for (let i = 0; i < b.lines; i++) out.push(LF)
        break
      case 'barcode': {
        align(b.align ?? 'center')
        const data = ascii(b.symbology === 'ean13' ? b.value.slice(0, 12) : b.value)
        // ESC b n1 n2 n3 n4 data RS: n1 symbology (3 = EAN-13, 6 = Code128), n2 text under (2), n3 width, n4 height.
        out.push(ESC, 0x62, b.symbology === 'ean13' ? 0x33 : 0x36, b.show_text === false ? 0x31 : 0x32, 0x32, 80, ...data, 0x1e, LF)
        break
      }
      case 'qr':
        align(b.align ?? 'center')
        line(b.value)
        break
      case 'image':
        break
    }
  }

  doc.blocks.forEach(block)
  align('left')
  out.push(LF, LF, LF)
  if (doc.kind === 'label' || doc.cut !== false) {
    if (p.cut === 'full') out.push(ESC, 0x64, 0x02)
    else if (p.cut === 'partial') out.push(ESC, 0x64, 0x03)
  }
  return { bytes: Uint8Array.from(out) }
}
